/*
 * @Date: 2022-08-15 14:59:17
 * @LastEditTime: 2022-10-06 15:47:03
 * @Description:
 */
import { net_collection } from "@/api/http";
export const API_GetCollectDataHeaderList = (...params) =>
  net_collection.post("/api/STDSDC03C01/GetCollectDataHeaderList", ...params);

export const API_Delete = (...params) =>
  net_collection.post("/api/STDSDC03C01/Delete", ...params);
